// Core
import {
  Box,
  Text
} from '@chakra-ui/react';

const LMCTTokensTransactions = ({ userData }) => {
  return (
  	<>
		<Box 
	      textAlign="center" 
	      py="40px" 
	      maxW={{sm: '325px'}} 
	      left="50%" 
	      position="relative" 
	      transform="translate(-50%, 0px)">
	        <Text variant="title-md" fontSize="20px" mt="20px" pb="9px" letterSpacing="-0.4px">Coming soon</Text>
	        <Text></Text>
	    </Box>
    </>
  );
};

export default LMCTTokensTransactions;